export enum ProjectConfigurationName {
    Project,
    Elements,
    Exports,
    Template,
    Workflow,
    Flux
}
